import { useContext, useEffect, useState } from 'react'
import styles from './imageMenu.module.css'
import DeleteIcon from '../../../../assets/svg/deleteIcon'
import BgColorMenu from '../textMenu/bgColorMenu'
import borderColors from './borderMenuColors.module.css'
import CornerMenu from './cornerMenu/cornerMenu'
import BorderRadius from './cornerMenu/borderRadius'
import RangeSlider from './rangeSlider/rangeSlider'
import BrightnessIcon from '../../../../assets/svg/brightnessIcon'
import ContrastIcon from '../../../../assets/svg/contrastIcon'
import MobileDisplayContext from '../../../../context/mobileDisplayContext'
import RotateIcon from '../../../../assets/svg/rotateIcon'

function ImageMenu(props)
{
    const mobileDisplayContext = useContext(MobileDisplayContext)

    const borderColorSetter = ()=>{
        if(props.element.class)
        {
            const borderColor = props.element.class.find(x=>x.includes('borderBg'))
            return borderColor || 'borderBgBlack6'
        }
        else
        {
            return 'borderBgBlack6'
        }
    }

    const borderWidthSetter = () =>{
        if(props.element.class)
        {
            const borderWidth = props.element.class.find(x=>x.includes('borderWidth'))
            return borderWidth || 'borderWidth1'
        }
        else
        {
            return 'borderWidth1'
        }
    }

    const borderRadiusSetter = () =>{
        if(props.element.class)
        {
            const borderRadius = props.element.class.find(x=>x.includes('borderRadius'))
            return borderRadius || 'borderRadius1'
        }
        else
        {
            return 'borderRadius1'
        }
    }

    const brightnessSetter = () =>{
        return props.element.brightness || props.element.brightness == 0?props.element.brightness:1
    }

    const contrastSetter = () =>{
        return props.element.contrast || props.element.contrast == 0?props.element.contrast:1
    }

    const [display,setDisplay] = useState(false)
    const [displayColorMenu,setDisplayColorMenu] = useState(false)
    const [borderColor,setBorderColor] = useState(borderColorSetter())
    const [displayBorderWidthMenu,setDisplayBorderWidthMenu] = useState(false)
    const [borderWidth,setBorderWidth] = useState(borderWidthSetter())
    const [displayCornerMenu,setDisplayCornerMenu] = useState(false)
    const [borderRadius,setBorderRadius] = useState(borderRadiusSetter())
    const [displayBrightnessMenu,setDisplayBrightnessMenu] = useState(false)
    const [brightness,setBrightness] = useState(brightnessSetter())
    const [displayContrastMenu,setDisplayContrastMenu] = useState(false)
    const [contrast,setContrast] = useState(contrastSetter())
    const [photoError,setPhotoError] = useState(false)

   useEffect(()=>{
        setTimeout(()=>{
            setDisplay(props.display)
        },10)
        if(!props.display)
        {
            setDisplayColorMenu(false)
            setDisplayBorderWidthMenu(false)
            setDisplayCornerMenu(false)
            setDisplayBrightnessMenu(false)
            setDisplayContrastMenu(false)
        }
    },[props.display])

    useEffect(()=>{
        if(props.element.type === "img")
        {
            props.element.setBrightness(brightness)
            props.setEditUpdate(!props.editUpdate)
        }
    },[brightness])

    useEffect(()=>{
        if(props.element.type === "img")
        props.element.setContrast(contrast)
        props.setEditUpdate(!props.editUpdate)
    },[contrast])

    const setBorderColorFunc = (color) =>{
        if(borderWidth === "borderWidth1")
        {
            props.element.removeClass("borderWidth1")
            props.element.addClass(`borderWidth3`)
            setBorderWidth(`borderWidth3`)
        }
        setBorderColor(color)
        props.setEditUpdate(!props.editUpdate)
    }

    const colorSetter = () =>{
        const color = borderColor.split('border')[1]
        if(!color)
        {
            return 'borderBgBlack6'
        }
        const array = color.split('')
        array.splice(0,1,array[0].toLowerCase())
        return array.join('')
    }

    const borderWidthClicked = (width) =>
    {
        const classes = props.element.class
        const filtered = classes.filter(x => x.includes('borderWidth'))
        filtered.forEach(x => {
            props.element.removeClass(x)
        });
        const newClass = `borderWidth${width}`
        props.element.addClass(newClass)
        setBorderWidth(newClass)
        props.setEditUpdate(!props.editUpdate)
    }

    const cornerItemClicked = (cut) =>{
        const classes = props.element.class
        const filtered = classes.filter(x => x.includes('borderRadius'))
        filtered.forEach(x => {
            props.element.removeClass(x)
        });
        const newClass = `borderRadius${cut}`
        props.element.addClass(newClass)
        setBorderRadius(newClass)
        props.setEditUpdate(!props.editUpdate)
    }

    const boardEvent = (e) =>{
        if(!e.target.classList.contains(styles.borderColor) && !e.target.classList.contains(styles.colorPreview))
        {
            setDisplayColorMenu(false)
        }
        if(!e.target.classList.contains(styles.borderWidth) && !e.target.classList.contains(styles.borderWidthPreview))
        {
            setDisplayBorderWidthMenu(false)
        }
        if(!e.target.classList.contains(styles.cornerItem) && !e.target.classList.contains('borderRadiusComponent'))
        {
            setDisplayCornerMenu(false)
        }
        if(!e.target.classList.contains(styles.brightnessItem) && !e.target.classList.contains('range') && !e.target.classList.contains('brightnessSvg'))
        {
            setDisplayBrightnessMenu(false)
        }
        if(!e.target.classList.contains(styles.contrastItem) && !e.target.classList.contains('range') && !e.target.classList.contains('contrastSvg'))
        {
            setDisplayContrastMenu(false)
        }
    }

    useEffect(()=>{
        if(props.element)
        {
            if(props.element.loadingError)
            {   
                setPhotoError(true)
            }
            else
            {
                setPhotoError(false)
            }
            setBorderColor(borderColorSetter())
            setBorderWidth(borderWidthSetter())
            setBorderRadius(borderRadiusSetter())
            setBrightness(brightnessSetter())
            setContrast(contrastSetter())
        }
    },[props.element])


    useEffect(()=>{
        window.addEventListener('click',boardEvent)
        return () =>{
            window.removeEventListener('click',boardEvent)
        }
    },[])

    const rotateImage = (e) =>
    {
        const classes = props.element.class
        const rotate = classes.find(x => x.includes('imgRotate'))
        let newClass
        if(rotate)
        {
            props.element.removeClass(rotate)
            const degrees = Number(rotate.split('imgRotate')[1])
            newClass = `imgRotate${degrees+90 >= 360?0:degrees+90}`
        }
        else
        {
            newClass = `imgRotate90`
        }
        props.element.addClass(newClass)
        props.setEditUpdate(!props.editUpdate)
    }

    return (
        <div className={`${styles.container} ${display?styles.display:''}`}>

            {!photoError && <>

            <div className={`${styles.item} ${styles.borderColor}`} onClick={e=>setDisplayColorMenu(!displayColorMenu)}>
                <div className={`${styles.colorPreview} ${borderColors[borderColor]}`}></div>
                {displayColorMenu && <BgColorMenu imageCenter={mobileDisplayContext.mobileDisplay === 'phone'} changeBgColor={setBorderColorFunc} border={true} color={colorSetter()} item={props.element}/>}
            </div>
            
            <div className={`${styles.item} ${styles.borderWidth}`} onClick={e=>setDisplayBorderWidthMenu(!displayBorderWidthMenu)}>
                <div className={styles.borderWidthPreview}></div>
                {displayBorderWidthMenu && <ul className={styles.widthMenu}>
                    <li className={`${styles.borderWidthOption} ${borderWidth==="borderWidth6"?styles.selected:''}`} onClick={e=>borderWidthClicked(6)}>
                        <div className={styles.width6}></div>
                    </li>
                    <li className={`${styles.borderWidthOption} ${borderWidth==="borderWidth5"?styles.selected:''}`} onClick={e=>borderWidthClicked(5)}>
                        <div className={styles.width5}></div>
                    </li>
                    <li className={`${styles.borderWidthOption} ${borderWidth==="borderWidth4"?styles.selected:''}`} onClick={e=>borderWidthClicked(4)}>
                        <div className={styles.width4}></div>
                    </li>
                    <li className={`${styles.borderWidthOption} ${borderWidth==="borderWidth3"?styles.selected:''}`} onClick={e=>borderWidthClicked(3)}>
                        <div className={styles.width3}></div>
                    </li>
                    <li className={`${styles.borderWidthOption} ${borderWidth==="borderWidth2"?styles.selected:''}`} onClick={e=>borderWidthClicked(2)}>
                        <div className={styles.width2}></div>
                    </li>
                    <li className={`${styles.borderWidthOption} ${borderWidth==="borderWidth1"?styles.selected:''}`} onClick={e=>borderWidthClicked(1)}>
                        <p>Brak</p>
                    </li>
                </ul>}
            </div>
            <div className={`${styles.item} ${styles.cornerItem}`} onClick={e=>setDisplayCornerMenu(!displayCornerMenu)}>
                <div className={styles.borderRadiusPreview}>
                    <BorderRadius borderRadius={borderRadius}/>
                </div>
                {displayCornerMenu && <CornerMenu borderRadius={borderRadius} cornerItemClicked={cornerItemClicked}/>}
            </div>
            <div className={`${styles.item} ${styles.brightnessItem}`} onClick={e=>!e.target.classList.contains('range') && setDisplayBrightnessMenu(!displayBrightnessMenu)}>
                <BrightnessIcon />
                {displayBrightnessMenu && <div className={`${styles.filterMenu} range`}>
                    <RangeSlider property={brightness} setProperty={setBrightness}/>
                </div>}
            </div>
            <div className={`${styles.item} ${styles.contrastItem}`} onClick={e=>setDisplayContrastMenu(!displayContrastMenu)}>
                <ContrastIcon />
                {displayContrastMenu && <div className={`${styles.filterMenu} range`}>
                    <RangeSlider property={contrast} setProperty={setContrast}/>
                </div>}
            </div>

            <div className={`${styles.item} ${styles.rotateItem}`} onClick={rotateImage}>
                <RotateIcon />
            </div>

            <div className={styles.line}></div>

            </>}
            <div className={`${styles.item} ${styles.deleteItem}`} onClick={e=>props.deleteItem(props.element.id)}>
                <DeleteIcon class={styles.deleteSVG}/>
            </div>


            
            
        </div>
    )
}

export default ImageMenu